import {
  Box,
  styled,
  TableRow,
  TableCell,
  Button,
  Grid,
  TextField,
  InputAdornment,
  MenuItem,
  Select,
  FormControl,
  InputLabel
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import React, { useEffect, useState } from 'react';
import PageHeader from '../../../components/PageHeader';
import Table from '../../../components/Table';

import IOSSwitch from '../../../components/IOSSwitch';
import { Gate, GateType } from '../../../schema/gate';
import { Link } from 'react-router-dom';
import { TableResponse } from '../../../schema/helper';
import AreaFromInput from '../../../components/formInput/AreaFromInput';
import { formatTime } from '../../../util';
import { api } from '../../../api';
const tableHead = [
  'ชื่อประตู',
  'รหัสพื่นที่',
  'ชื่อพื่นที่',
  'ชนิดประตู',
  'ประเภท',
  'สถานะ',
  'เวลาเปิด-ปิด',
  'รหัสอุปกรณ์',
  'ชื่ออุปกรณ์',
  'เพิ่มเติม'
];

const GatePage: React.FC = () => {
  const [data, setData] = useState<TableResponse<Gate> | null>(null);

  const [filterName, setFilterName] = useState<string>('');
  const [filterSN, setFilterSN] = useState<string>('');
  const [filterAreaID, setFilterAreaID] = useState<number | null>(null);
  const [filterIsMain, setFilterIsMain] = useState<boolean | null>(null);
  const [filterDoorTypeID, setFilterDoorTypeID] = useState<string>('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [gateTypeList, setGateTypeList] = useState<GateType[]>([]);

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handlePageChange = (_: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const updateGateData = (gate_id: number, { is_active }: { is_active: boolean }) => {
    if (isLoading) {
      return;
    }
    setIsLoading(true);
    api
      .patch(`/gate/${gate_id}`, {
        is_active: is_active
      })
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    if (filterName == '' && filterSN == '' && filterAreaID == null && filterDoorTypeID == '') {
      const searchParams = new URLSearchParams();
      searchParams.set('offset', `${page * rowsPerPage}`);
      searchParams.set('limit', `${rowsPerPage}`);
      api.get<TableResponse<Gate>>(`/gate/table`, { params: searchParams }).then((res) => {
        const { data } = res;
        setData(data);
      });

      return;
    }
    const timeOut = setTimeout(() => {
      const searchParams = new URLSearchParams();
      if (filterName) {
        searchParams.set('name', `${filterName}`);
      }
      if (filterSN) {
        searchParams.set('sn', `${filterSN}`);
      }
      if (filterAreaID != null) {
        searchParams.set('area_id', `${filterAreaID}`);
      }
      if (filterDoorTypeID) {
        searchParams.set('gate_type', `${filterDoorTypeID}`);
      }
      searchParams.set('offset', `${page * rowsPerPage}`);
      searchParams.set('limit', `${rowsPerPage}`);
      api.get<TableResponse<Gate>>(`/gate/table`, { params: searchParams }).then((res) => {
        const { data } = res;
        setData(data);
      });
    }, 500);
    return () => clearTimeout(timeOut);
  }, [filterName, filterAreaID,filterSN,filterDoorTypeID, page, rowsPerPage]);

  useEffect(() => {
    api.get<GateType[]>(`/gate_type`).then((res) => {
      const { data } = res;
      setGateTypeList(data);
    });
  }, []);
  return (
    <Container>
      <PageHeader text="ประตู" />
      <Grid container spacing={2} marginTop={1}>
        <Grid item md={3}>
          <TextField
            id="search-text-label"
            label="ค้นหาชื่อประตู"
            variant="outlined"
            placeholder="ค้นหาชื่อประตู"
            onChange={(event) => setFilterName(event.target.value)}
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              )
            }}
            autoComplete={'off'}
          />
        </Grid>
        <Grid item md={3}>
          <TextField
            id="search-text-label"
            label="ค้นหารหัสอุปกรณ์"
            variant="outlined"
            placeholder="ค้นหารหัสอุปกรณ์"
            onChange={(event) => setFilterSN(event.target.value)}
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              )
            }}
            autoComplete={'off'}
          />
        </Grid>
        <Grid item md={3}>
          <AreaFromInput value={filterAreaID} onChange={(value) => setFilterAreaID(value)} />
        </Grid>
        <Grid item md={3}>
          <FormControl fullWidth>
            <InputLabel>{`ประเภทประตู`}</InputLabel>
            {/* <Select
              label={`ชนิดประตู`}
              variant="outlined"
              onChange={(e) => {
                const parsed = e.target.value;
                if (parsed === 'true') {
                  setFilterIsMain(true);
                  return;
                } else if (parsed === 'false') {
                  setFilterIsMain(false);
                  return;
                }
                setFilterIsMain(null);
              }}
              value={`${filterIsMain}`}
              autoComplete="off"
              required
            >
              <MenuItem value={'null'}>ทั้งหมด</MenuItem>
              <MenuItem value={'true'}>เข้า-ออก</MenuItem>
              <MenuItem value={'false'}>ทั่วไป</MenuItem>
            </Select> */}
            <Select
                label={`ประเภทประตู`}
                variant="outlined"
                onChange={(e) => {
                  setFilterDoorTypeID(e.target.value);
                  console.log(e.target.value)
                }}
                value={filterDoorTypeID}
                autoComplete="off"
                required
              >
                <MenuItem value="">ทั้งหมด</MenuItem>
                {gateTypeList.map((data, index) => (
                  <MenuItem key={index} value={`${data.id}`}>
                    {data.type_name}
                  </MenuItem>
                ))}
              </Select>
          </FormControl>
        </Grid>

        {/* <Grid item md sx={{ display: 'flex', justifyContent: 'end', height: '50px' }}>
          <Button component={Link} to={`/gate/create`} variant="contained" color="primary">
            เพิ่มข้อมูล
          </Button>
        </Grid> */}
      </Grid>
      <Box sx={{ mt: 2 }}>
        <Table
          heads={tableHead}
          count={data?.total ? data.total : 0}
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
        >
          {data?.data.map((data, index) => (
            <TableRow key={index}>
              {/* <TableCell align="center">{data.id}</TableCell> */}
              <TableCell align="center">{data.gate_name}</TableCell>
              <TableCell align="center">{data.area?.area_code}</TableCell>
              <TableCell align="center">{data.area?.area_name}</TableCell>
              <TableCell align="center">{data.is_main ? 'เข้า-ออก' : 'ทั่วไป'}</TableCell>
              <TableCell align="center">{data.gate_type?.type_name}</TableCell>
              <TableCell align="center">
                <IOSSwitch
                  defaultChecked={data.is_active}
                  onChange={(_, checked) =>
                    updateGateData(data.id, {
                      is_active: checked
                    })
                  }
                />
              </TableCell>

              <TableCell align="center">
                {data.shift_type
                  ? `${data.shift_type?.open_time?.substring(
                      0,
                      5
                    )} - ${data.shift_type?.close_time?.substring(0, 5)} (${
                      data.shift_type?.type_name
                    })`
                  : ''}
              </TableCell>
              <TableCell align="center">{data.acc_device_id}</TableCell>
              <TableCell align="center">{data.acc_device_name}</TableCell>
              <TableCell align="center">
                <Grid container spacing={2} rowSpacing={2} justifyContent="center">
                  <Grid item>
                    <Button
                      component={Link}
                      to={`/gate/${data.id}/edit`}
                      variant="contained"
                      color="warning"
                    >
                      แก้ไข
                    </Button>
                  </Grid>
                </Grid>
              </TableCell>
            </TableRow>
          ))}
        </Table>
      </Box>
    </Container>
  );
};

export default GatePage;

const Container = styled('div')`
  padding: 24px;
`;
